import { NoWrap, Link } from '@components/Common.styles';
import {
  TableColumns,
  createTableColumnsV2,
} from '@components/TableV2/helpers/createTableColumnsV2';
import { useI18n } from '@hooks/useI18n';
import { IEnrichedMinorArrearsContract } from './types';

export const useGetMinorArrearsColumns = () => {
  const { getLocaleCurrencyValue, getLocaleDate, translate } = useI18n();

  const columns: TableColumns<IEnrichedMinorArrearsContract> = [
    {
      field: 'arrears_amount',
      label: translate('LABEL.AMOUNT'),
      mapCustomJSX: ({
        row: {
          arrears_amount: { amount, currency },
        },
      }) => (
        <NoWrap>{getLocaleCurrencyValue({ value: amount, currency })}</NoWrap>
      ),
    },
    {
      field: 'maturity_date',
      label: translate('OPS_PORTAL.LABEL.MATURITY_DATE'),
      mapCustomValue: ({ row }) => getLocaleDate({ date: row?.maturity_date }),
    },
    {
      field: 'contract',
      label: translate('OPS_PORTAL.TITLE.CONTRACT'),
      mapCustomJSX: ({ row }) => (
        <Link to={`/all_contracts/${row.external_uuid}`}>
          {row.payment_plan_ref}
        </Link>
      ),
    },
  ];

  return createTableColumnsV2({ columns });
};
